var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.allProjects.length === 0)?_c('NoProjects'):_c('div',{staticClass:"mb-8",attrs:{"id":"projects-grid-content"}},[_c('ProjectsDataIterators')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }